<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="专家信息变更" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button :loading="loading || saving" type="danger" v-if="editData.djzt === '提交'" @click="unSubmit">撤销</a-button>
            </template>
            <a-divider></a-divider>
            <a-spin :spinning="loading">
                <a-form ref="form" class="fun-edit-form" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" style="padding:10px 20px;">
                    <a-row :gutter="[0, 6]">
                        <a-col :span="6">
                            <a-form-item label="变更单编号">
                                <a-input ref="bgdbh" v-model="editData.bgdbh" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="变更日期">
                                <a-input ref="bgrq" v-model="editData.bgrq" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="专家姓名">
                                <a-input ref="zjxm2" v-model="editData.zjxm2" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="单位名称">
                                <a-input ref="dwmc2" v-model="editData.dwmc2" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="专业一">
                                <a-input ref="zymc2" v-model="editData.zymc2" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="子专业一">
                                <a-input ref="zzymc2" v-model="editData.zzymc2" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="专业二">
                                <a-input-search ref="zymc1_bf" disabled v-model="editData.zymc1_bf" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="子专业二">
                                <a-input ref="zzymc1_bf" disabled v-model="editData.zzymc1_bf" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="性别">
                                <FGDictSelectCN ref="xb2" dictNo="RY100101" v-model="editData.xb2" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="职务">
                                <a-input ref="zw2" v-model="editData.zw2" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="职称">
                                <a-input ref="zc2" v-model="editData.zc2" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="身份证号">
                                <a-input ref="zjhm2" v-model="editData.zjhm2" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="手机号">
                                <a-input ref="sjhm2" v-model="editData.sjhm2" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="通讯地址">
                                <a-input ref="txdz2" v-model="editData.txdz2" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="毕业院校">
                                <a-input ref="byyx2" v-model="editData.byyx2" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="学位">
                                <a-input ref="xw2" v-model="editData.xw2" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="毕业时间">
                                <a-date-picker ref="bysj2" v-model="editData.bysj2" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="学历专业">
                                <a-input ref="xlzymc2" v-model="editData.xlzymc2" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-item label="工作业绩" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                <a-textarea ref="gzyj2" v-model="editData.gzyj2" :rows="3" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-item label="担任外系统评委情况" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                <a-textarea ref="drwxtpwqk2" v-model="editData.drwxtpwqk2" :rows="3" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-item label="工作简介" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                <a-textarea ref="gzjj2" v-model="editData.gzjj2" :rows="3" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="用户名">
                                <a-input ref="yhm2" v-model="editData.yhm2" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="录入人">
                                <a-input ref="lrr" v-model="editData.lrr" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="录入日期">
                                <a-input ref="lrrq" v-model="editData.lrrq" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="备注">
                                <a-input ref="bz" v-model="editData.bz" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="变更类型">
                                <FGDictSelectCN ref="bglx" dictNo="ZJ200101" v-model="editData.bglx" disabled />
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
            </a-spin>
        </a-page-header>
    </div>
</template>
<script>
export default {
    name: "ZjxxbglrForm",
    props: ["showForm", "dataId"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            // 培训记录明细数据
            editItemData: [],
            editItemDataLoading: false
        };
    },
    computed: {
        subTitle() {
            return "查看";
        },
        // 是否显示编辑界面
        formIsVisible: {
            get() {
                return this.showForm;
            },
            set(newVal) {
                this.$emit("update:showForm", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return this.editDataLoading || this.editItemDataLoading;
        }
    },
    activated() {
        // 修改，加载数据
        this.loadData();
    },
    methods: {
        // 根据id查询需要编辑的数据
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zjxx/zjxxbg/selectById",
                    {
                        id: this.editDataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.editIsVisible = false;
                    }
                });
        },
        unSubmit() {
            this.$FG_http
                .post("./api/main/zjxx/zjxxbg/unSubmit", {
                    id: this.editData.id
                })
                .then(({ success, data, errMsg }) => {
                    this.tableDataLoading = false;
                    if (success) {
                        // 设置当前行
                        this.editDataId = this.editData.id;
                        // 返回列表
                        this.onBack();
                    }
                });
        },
        // 返回列表
        onBack() {
            this.formIsVisible = false;
        }
    }
};
</script>
